'use client';

import GeneralLoader from '@components/ui/GeneralLoader';
import { useBackButtonLoader } from '@hooks/useBackButtonLoader';

export default function BackButtonLoader() {
  const isLoading = useBackButtonLoader();

  return <>{isLoading && <GeneralLoader />}</>;
}
